import './user_profile_view.js.coffee'
Customer.Users ||= {}

class Customer.Users.UserProfilePreviewView extends Customer.Users.UserProfileView

  template: JST["backbone/templates/customer/users/user_profile_preview"]

  events:
    'click .preview-tab': 'openProfileOnTab'
    'click #merge-candidates-clickable-notification': '_mergeProfiles'

  initialize: (@options = {}) ->
    super(@options)
    @mergeCandidates = @options.mergeCandidates
    @errorMessage = @options.errorMessage || I18n.t('user_profiles.cant_be_loaded')
    @response = @options.userProfileResponse

  show: ->
    @doGetProfile()

  render: ->
    @$el.html(@template())
    @legendPresent = false
    @showMergeCandidatesNotification() if @mergeCandidates > 0

  updateCandidateCount: (count) ->
    @mergeCandidates = count
    if @mergeCandidates > 0
      @showMergeCandidatesNotification()
    else
      @hideMergeCandidatesNotification()

  showMergeCandidatesNotification: ->
    message =  I18n.t(
      'customer.dashboard.conversations.details.box.user.merge_candidates',
      { candidatesCount: @mergeCandidates }
    )
    @$el.find('#merge-candidates-clickable-notification span').text(message)
    @_showMergeCandidatesNotification()

  hideMergeCandidatesNotification: ->
    @_hideMergeCandidatesNotification()

  doGetProfile: =>
    if I18n.t('google_play.user.anonymous') == @id && @source == "google_play"
      @showError()
    else
      @renderResponse(@response)

  _toggleMergeCandidatesNotification: (show) =>
    @$el.find('#merge-candidates-clickable-notification').toggleClass('d-none', not show)

  _showMergeCandidatesNotification: =>
    @_toggleMergeCandidatesNotification(true)

  _hideMergeCandidatesNotification: =>
    @_toggleMergeCandidatesNotification(false)

  _mergeProfiles: =>
    profile = @_userProfileFromResponse()
    return unless profile

    userProfileMergeView = new Customer.Users.ProfileMergeView originalProfile: profile
    @listenTo userProfileMergeView, 'profile:merged', (response) =>
      @renderResponse(response)
      @_clearMergeCandidates()
    @listenTo userProfileMergeView, 'profile:merge_excluded', @_clearMergeCandidates
    @$el.find('#profile-merge').html(userProfileMergeView.render().el)
    userProfileMergeView.open()

  _clearMergeCandidates: =>
    @mergeCandidates = 0
    @_hideMergeCandidatesNotification()
    @trigger('profile:cleared_candidates')

  _userProfileFromResponse: =>
    return null unless @response
    new Profile.UserProfile.ExtendedUserProfile @response

  validateFieldsAreFilled: (fields) ->
    @mainProfileView.profileAttributesView.validateFieldsAreFilledAndExists(fields)

  isBeingModified: ->
    @mainProfileView.profileAttributesView.isBeingModified()

  onAttributesChanged: (response) =>
    @renderResponse(response)
    @trigger('recalculate:merge:candidates')

  renderResponse: (response) =>
    return unless response
    @response = response
    if response.profile
      @profileId = response.id
      @editableAttributes = response.editable_attributes
      @renderMainProfile(response)
      @$el.find('#preview-body.processing').removeClass('processing')
    else
      @showError()

  showError: =>
    errorMsg = $("<div>#{I18n.t('user_profiles.cant_be_loaded')}</div>").addClass('profile-error')
    @$el.find('#preview-body.processing').removeClass('processing').html(errorMsg)
    @$el.find('.preview-tab').addClass('disabled')

  openProfileOnTab: (event) ->
    @_keepCustomerSessionAlive()
    @$el.find('#user-profile').remove()
    @userProfileView = new Customer.Users.UserProfileView(source: @source, id: @socialId, session: @session, openTab: event.currentTarget.id)
    @listenTo @userProfileView, 'profile_custom_attributes:change', (response) =>
      @response = response
      @mainProfileView.update profile: @response.profile
    @userProfileView.render()
    @$el.append(@userProfileView.el)
    @listenTo(@userProfileView, 'profile:attributes-updated', @renderResponse)
    @userProfileView.show()

  renderMainProfile: (response) ->
    @searchQuery = new Monitoring.Models.SearchQuery({}, { use_defaults: false })
    for socialUser in response.social_users
      @searchQuery.addSocialNetworkId(
        value: socialUser.social_network_id
        name: socialUser.values.name
      )
    response.profile.id = response.id
    @mainProfileView = new Customer.Users.ProfilePreviewMainView(
      source: @source
      profile: response.profile
      social_users: response.social_users
      editable_attributes: response.editable_attributes
      ticket_social_user_id: @socialId
    )
    @listenTo @mainProfileView, 'profile:social-user-removed', @renderResponse
    @listenTo @mainProfileView, 'profile_custom_attributes:change', @onAttributesChanged
    @listenTo @mainProfileView, 'profile_custom_attributes:restore', =>
      @renderResponse(@response)
    @$el.find('.tab-content').html @mainProfileView.render().el
    @mainProfileView.afterRender()
    @trigger('render_finished')

  _keepCustomerSessionAlive:->
    Backbone.trigger 'customerSession:keepAlive'

  setuserProfileResponse: (userProfileResponse) =>
    @response = userProfileResponse
    @show()

  onAttributesValidationError: (userProfileAttributeErrors) =>
    @mainProfileView.onAttributesValidationError(userProfileAttributeErrors)

  onTicketClose: =>
    @mainProfileView.onTicketClose()
